import { useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { Briefcase, DollarSign, Calendar, CalendarDays, AlarmClock } from 'lucide-react';

export default function Jobs() {
  const { userProfile } = useContext(UserContext);
  
  // Format day of week name
  const getDayName = (day: number): string => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[day] || 'Unknown';
  };

  return (
    <div className="max-w-6xl mx-auto p-4 sm:px-6 pb-6 space-y-6">
      <div className="bg-white w-full rounded-xl shadow-sm border border-gray-200/50">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center bg-white">
          <div className="flex items-center gap-3">
            <Briefcase className="w-6 h-6 text-indigo-600" />
            <h2 className="text-xl font-bold text-gray-800">My Jobs</h2>
          </div>
          {/* <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button> */}
        </div>
        
        <div className="p-6">
          {userProfile?.jobs && userProfile.jobs.length > 0 ? (
            <div className="space-y-6">
              {userProfile.jobs.map((job, index) => (
                <div key={index} className="bg-white shadow-sm rounded-lg p-5 border border-gray-200/70">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-indigo-50 rounded-lg">
                      <Briefcase className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-lg text-gray-800">{job.jobName}</h3>
                      
                      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex items-center gap-2">
                          <DollarSign className="w-4 h-4 text-green-500" />
                          <span className="text-gray-600">Earns {job.points} points</span>
                        </div>
                        
                        <div className="flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-blue-500" />
                          <span className="text-gray-600">
                            Started: {new Date(job.jobStartDate).toLocaleDateString()}
                          </span>
                        </div>
                        
                        <div className="flex items-center gap-2">
                          <CalendarDays className="w-4 h-4 text-purple-500" />
                          <span className="text-gray-600">
                            Paid every {job.payEvery} week(s) on {getDayName(job.payDayOfWeek)}
                          </span>
                        </div>
                        
                        <div className="flex items-center gap-2">
                          <AlarmClock className="w-4 h-4 text-orange-500" />
                          <span className="text-gray-600">
                            Last earned: {new Date(job.jobLastEarnedOn).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-10">
              <Briefcase className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-800 mb-1">No Jobs Found</h3>
              <p className="text-gray-500">You don't have any assigned jobs yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
